import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import "./Room.scss";
import Stopwatch from "../stopwatch/StopWacth";
import BillData from "../../data/Bill/BillData";
import Menu from "../menu/Menu";
import handleDownloadBillDatas from "../downloadword/DownloadWord";
import Clock from "../clock/Clock";
import { postBill } from "../../api/postBill";
import BillDetails from "../billdatadetails/BillDataDetails";
import ReactToPrint from "react-to-print";
import { ComponentToPrint } from "../BillPaper.jsx/Bill";
import { AppContext } from "../../App";
import EmailSender from "../emailsender/EmailSender";
import { nanoid } from "nanoid";

const Room = ({ id }) => {
  const [Time, SetTime] = useState("0:0");
  const [billData, setBillData] = useState(BillData);
  const [activePayment, setActivePayment] = useState(false);
  const [showBill, setShowBill] = useState(false);
  const [totalTimePrice, setTotalTimePrice] = useState(0);
  const [orderList, setOrderList] = useState([]);
  const [debt, setDebt] = useState("");
  const [clear, setClear] = useState(false);
  const [priceOfTime, setPriceOfTime] = useState(0);
  const [backStart, setBackStart] = useState(true);
  const [responseStatus, setResponseStatus] = useState("");
  const [checkSuccess, setcheckSuccess] = useState(false);
  const componentRef = useRef();
  const { dataPrices } = useContext(AppContext);

  useEffect(() => {
    if (id && dataPrices) {
      const filterTotalPrice =
        id !== "6V" && id !== "7V" && id !== "8V" && id !== "9V" && id !== "10V"
          ? dataPrices.Price
          : dataPrices.PriceVip;

      setPriceOfTime(filterTotalPrice);
    }
  }, [id, dataPrices, setPriceOfTime]);

  useEffect(() => {
    if (Time && Time !== null) {
      const price =
        id !== "6V" && id !== "7V" && id !== "8V" && id !== "9V" && id !== "10V"
          ? dataPrices.Price / 6
          : dataPrices.PriceVip / 6;

      const [hoursString, minutesString] = Time.split(":");
      const hours = parseInt(hoursString, 10);
      const minutes = parseInt(minutesString, 10);
      const totalMinutes = hours * 60 + minutes;

      let totalPrice;
      if (totalMinutes % 10 > 0) {
        const totalPirce = Math.floor(totalMinutes / 10);
        totalPrice = totalPirce * price + price;
      } else {
        const totalPirce = Math.floor(totalMinutes / 10);
        totalPrice = totalPirce * price;
      }

      setTotalTimePrice(totalPrice);
    }
  }, [Time, dataPrices, id]);

  const payment = () => {
    setActivePayment(true);
    setShowBill(true);
    setBackStart(true);
  };

  const handleChangeInputDebt = (event) => {
    const value = event.target.value;
    setDebt(value);
  };

  const updateTimeAndPrice = useCallback(
    (totalTime, totalTimePrice) => {
      const totalPayment =
        orderList.reduce((total, item) => total + item.totalPrice, 0) +
        totalTimePrice;

      setBillData((prevData) => ({
        ...prevData,
        TotalTime: totalTime,
        PriceOfTotalTime: totalTimePrice,
        TotalPayment: totalPayment,
        OrderList: orderList,
        Debt: debt,
        idRoom: id,
        qrContent: nanoid(15),
        PriceOfTime: priceOfTime,
      }));
    },
    [orderList, debt, id, priceOfTime]
  );

  useEffect(() => {
    if (showBill) {
      updateTimeAndPrice(Time, totalTimePrice, id);
    }
  }, [
    activePayment,
    showBill,
    Time,
    totalTimePrice,
    orderList,
    debt,
    priceOfTime,
    id,
    updateTimeAndPrice,
  ]);

  const resetBillData = useCallback(() => {
    setBillData({
      ...BillData,
      idRoom: id, // Preserve the idRoom value
    });
  }, [id]);

  const generateBillName = useCallback(() => {
    return `${billData.idRoom}-${billData.Date}-${billData.Paymentime}-${billData.TotalPayment}${
      billData.Debt !== "" ? "-" + billData.Debt : ""
    }`;
  }, [billData]);

  const handPrint = () => {
    postBill(billData, setResponseStatus);
    setcheckSuccess(true);
  };

  const clearAll = useCallback(() => {
    setActivePayment(false);
    setShowBill(false);
    setOrderList(null);
    setDebt("");
    setTotalTimePrice(0);
    SetTime("0:0");
    setClear(true);
    resetBillData();
    setcheckSuccess(false);
    setResponseStatus("");
    EmailSender(billData, checkSuccess);
  }, [resetBillData, billData, checkSuccess]);

  useEffect(() => {
    if (responseStatus !== 200 && responseStatus !== "") {
      handleDownloadBillDatas(billData, generateBillName());
    }
  }, [responseStatus, billData, generateBillName]);

  useEffect(() => {
    if (checkSuccess === true && responseStatus !== "") {
      clearAll();
    }
  }, [checkSuccess, responseStatus, clearAll]);

  useEffect(() => {
    if (clear === true) {
      SetTime("0:0");
      setClear(false);
    }
  }, [clear]);

  useEffect(() => {
    if (backStart === false) {
      setActivePayment(false);
    }
  }, [backStart]);

  

  return (
    <div className="frame-room">
      <div className="frame-left-item-room">
        <div className="frame-button-action-left">
          <div className="stopwatch-payment">
            <Stopwatch
              Time={SetTime}
              check={activePayment}
              Clear={clear}
              backStart={setBackStart}
            />
            <div className="frame-button-payment">
              <button
                onClick={payment}
                className="button-payment button-app-payment"
              >
                Thanh Toán
              </button>
            </div>
          </div>
        </div>

        <div className="frame-layout-orderlist">
          <Menu selectedItemList={setOrderList} Clear={clear} />
        </div>
      </div>
      <div className="frame-right-item-room">
        <div className="frame-top-right-item-room">
          <Clock />
          <div className="frame-input-debt">
            <input
              type="text"
              placeholder="Nhập Tên Người Nợ"
              onChange={handleChangeInputDebt}
              value={debt}
            />
          </div>
        </div>
        <div className="frame-display-bill">
          {showBill === true ? <BillDetails billData={billData} /> : ""}
        </div>

        <div className="frame-button-print-bill">
          
          <ReactToPrint
            trigger={() => (
              <button
                className="button-app-payment button-app-inbill"
                disabled={showBill === false}
              >
                Xuất Hóa Đơn
              </button>
            )}
            content={() => componentRef.current}
            onAfterPrint={handPrint}
          />
          <div style={{ display: "none" }}>
            <ComponentToPrint ref={componentRef} billData={billData} />
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Room;
